<template>
  <v-container grid-list-sm text-xs-left>

    <v-layout wrap row>
      <v-btn
          icon
          @click="navigate('*goBack*')"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <div class="pa-2 headline">
        {{ startupId === 'newStartup' ? 'Create new startup' : startupName }}
      </div>
    </v-layout>

    <FormStartupRegistration @update="updateScore1" @updateName="updateName" @updateApproved="updateApproved"
                             :startupId="startupId" ref="form1"></FormStartupRegistration>
    <FormStartupRegistrationAdmin @update="updateScore2" :startupId="startupId"
                                  ref="form2"></FormStartupRegistrationAdmin>
    <v-spacer></v-spacer>
    <v-flex xs4 class="pa-3">
      <v-text-field
          v-model="totalScore"
          label="Score"
          readonly
      >
        <template v-slot:append>
          <v-tooltip
              bottom
          >
            <template v-slot:activator="{ on }">
              <v-icon @click="showScoreTables=true" v-on="on">mdi-help-circle-outline</v-icon>
            </template>
            Click here to discover how the score is calculated
          </v-tooltip>
        </template>
      </v-text-field>
    </v-flex>

    <v-btn round dark color="green" @click="approveStartup">
      {{ startupId === 'newStartup' || approved === 1 ? 'Save' : 'Approve' }}
    </v-btn>
    <v-btn v-if="startupId === 'newStartup' || approved === 1" round dark color="red" @click="clear">
      Clear
    </v-btn>
    <v-btn v-else round dark color="red" @click="deleteStartupDialog=true">
      Discard
    </v-btn>

    <v-dialog
        v-model="deleteStartupDialog"
        max-width="650"
        persistent
    >
      <v-card>
        <v-card-title class="headline">Discarding {{ startupName }}</v-card-title>
        <v-card-text>
          Are you sure?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              flat="flat"
              @click="deleteStartupDialog=false"
          >
            Cancel
          </v-btn>
          <v-btn
              color="red"
              flat="flat"
              @click="discardStartup()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="showScoreTables"
        max-width="85%"
    >
      <v-card>
        <v-card-title class="headline">How to calculate the score</v-card-title>
        <v-card-text>
          <ScoreTables></ScoreTables>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="duplicateName" max-width="450">
      <v-card>
        <v-card-title class="headline error white--text">Startup creation failed</v-card-title>
        <v-card-text>{{ startupErrorDescription }}</v-card-text>
      </v-card>
    </v-dialog>

  </v-container>


</template>

<script>
import FormStartupRegistration from "@/pages/Admin/Innovation/FormStartupRegistration";
import FormStartupRegistrationAdmin from "@/pages/Admin/Innovation/FormStartupRegistrationAdmin";
import UrlsService from "@/helpers/UrlsService";
import TimeService from "@/helpers/TimeService";
import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
import RouterService from "@/helpers/RouterService";
import ScoreTables from "./ScoreTables";
import {mapGetters, mapState} from "vuex";
import _ from "lodash";
import router from "@/routes/router";


export default {
  name: "StartupInfo",
  components: {ScoreTables, FormStartupRegistration, FormStartupRegistrationAdmin},
  props: {
    startupId: String,
    //startupName: String,
    //approved: Number
  },
  data() {
    return {
      score1: 0,
      score2: 0,
      deleteStartupDialog: false,
      showScoreTables: false,
      startupName: "",
      approved: 0,
      duplicateName: false,
      startupErrorDescription: "",
      startup_init: {},
      navigateBack: false,
      created: false,
      unsavedAlert: "You have unsaved changes. Are you sure you wish to leave?",
    }
  },
  computed: {
    ...mapState({}),
    ...mapGetters('UserState', {
          userInfo: 'getUserInfo',
        }
    ),
    totalScore() {
      return this.score1 + this.score2
    }
  },

  mounted() {
    if (this.startupId === 'newStartup') {
      let part1_init = this.$refs.form1.returnFields();
      let part2_init = this.$refs.form2.returnFields();
      this.startup_init = {...part1_init, ...part2_init}

      window.addEventListener("beforeunload",(e) => this.loadPage(e));

      /*router.beforeEach((to,from,next) => {
        if (!this.navigateBack && this.checkChange()) {
          if (window.confirm(this.unsavedAlert)) {
            next()
          }
          } else {
            next()
          }
      });*/
    }
  },
  destroyed() {
    console.log("destr")
    if (this.startupId === 'newStartup') {
      window.removeEventListener('beforeunload', (e) => this.loadPage(e));
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.startupId === 'newStartup') {
      if (!this.navigateBack && this.checkChange()) {
        if (window.confirm(this.unsavedAlert)) {
          next()
        }
      } else {
        next()
      }
    }
    else {
      next()
    }
  },

  methods: {
    loadPage(e) {
      let message = "";
      if (this.checkChange()) {
        e.preventDefault()
        message = "You have unsaved changes. Are you sure you wish to leave?"
        console.log(e);
        e.returnValue = message
      }
      return message
    },

    updateName(name) {
      this.startupName = name;
    },
    updateApproved(approved) {
      this.approved = approved;
    },

    navigate(path) {
      console.log("navigate back")
      console.log("created: ",this.created);
      //console.log("checkChange: ",this.checkChange());
      this.navigateBack = true;
      if (this.startupId === 'newStartup' && !this.created && this.checkChange()) {
        console.log("not created and changed")
        if (window.confirm(this.unsavedAlert)) {
          RouterService.goTo(path);
        }
        else {
          this.navigateBack = false;
        }
      }
      else {
        console.log("else");
        RouterService.goTo(path);
      }

    },

    updateScore1(newData) {
      this.score1 = newData
    },
    updateScore2(newData) {
      this.score2 = newData
    },
    clear() {
      this.$refs.form1.clear();
      this.$refs.form2.clear();
    },
    discardStartup() {
      this.deleteStartupDialog = false;
      let part1 = this.$refs.form1.returnFields();
      let startup = {
        _id: this.startupId,
        Name: part1["Name"]
      }
      let requestUrl = {
        url: this.userInfo.role === "APPROVER_INNOVATION" ? UrlsService.deleteStartup : UrlsService.startupOperationProposal,
        timeout: TimeService.secondsToMillis(0),
      };

      let requestData = {
        interactionData: {
          text: "DELETE",
          startupRequest: {
            startup: startup
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Discard Startup",
        loading: "Waiting for startup elimination ...",
        error: "Cannot discard startup...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            this.navigate('*goBack*');

          });
    },
    createStartup(startup) {
      let requestUrl = {
        url: this.userInfo.role === "APPROVER_INNOVATION" ? UrlsService.createStartup : UrlsService.startupOperationProposal,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "CREATE",
          startupRequest: {
            startup: startup
          },
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: this.userInfo.role === "APPROVER_INNOVATION" ? "Startup created" : "Startup creation proposal. Wait until Approver verify your creation request.",
        loading: "Waiting for startup management operation...",
        error: "Cannot complete startup management operation...",
      };
      let options = {
        loadingType: "fullscreen+notification",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            this.startups = [];
            let response = responseSuccess.response;
            if (response != undefined && response.data !== undefined && response.data.responseStatus.code === 501) {
              this.duplicateName = true;
              this.startupErrorDescription = responseSuccess.response.data.responseStatus.description
            } else {
              this.created = true;
              this.navigate('*goBack*');
            }
          });
    },
    updateStartup(startup) {
      console.log("Sono qui");
      let requestUrl = {
        url: this.userInfo.role === "APPROVER_INNOVATION" ? UrlsService.updateStartup : UrlsService.startupOperationProposal,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "UPDATE",
          startupRequest: {
            startup: startup
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: this.userInfo.role === "APPROVER_INNOVATION" ? "Startup updated" : "Startup update proposal. Wait until Approver verify your update request.",
        loading: "Waiting for startup management operation...",
        error: "Cannot complete startup management operation...",
      };
      let options = {
        loadingType: "fullscreen+notification",
        timeout: TimeService.secondsToMillis(0),
      };

      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            this.startups = [];
            let response = responseSuccess.response;
            if (response != undefined && response.data !== undefined && response.data.responseStatus.code === 501) {
              this.duplicateName = true;
              this.startupErrorDescription = responseSuccess.response.data.responseStatus.description
            } else {
              this.navigate('*goBack*');
            }
          });
    },
    approveStartup() {
      if (this.$refs.form1.formValidate() & this.$refs.form2.formValidate()) {

        let part1 = this.$refs.form1.returnFields();
        let part2 = this.$refs.form2.returnFields();
        let startup = {...part1, ...part2}
        startup.approved = 1;
        startup["Score"] = this.totalScore;
        startup._id = this.startupId;


        if (this.startupId === "newStartup") {
          this.createStartup(startup);
        } else {
          this.updateStartup(startup);
        }
      }
    },

    checkChange() {
      //true if changed
      let part1 = this.$refs.form1.returnFields();
      let part2 = this.$refs.form2.returnFields();
      let startup = {...part1, ...part2}
      return !_.isEqual(startup,this.startup_init)
    }
  },

}
</script>

<style scoped>

</style>
